(() => {
  const button = document.querySelector('.mv-back-top');
  if (!button) return;
  let queued = false;
  const refresh = () => { button.hidden = window.scrollY < 400; queued = false; };
  window.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(refresh); }
  }, { passive: true });
  button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
  refresh();
})();
